export const MESSAGE_TIME_FORMAT = "hh:mm a";

export const MESSAGE_DATE_FORMAT = `MMMM d yyyy, ${MESSAGE_TIME_FORMAT}`;
